<div>
  <h3>Pending Actions (<span>{{summaryData.name}}</span>)</h3>
  <div class="flex-container">
    @if (summaryData.absences > 0) {
      <div class="flex-item highlight">
        <div><span>Absence:</span>
        <span class="mob">{{summaryData.absences}}</span></div>
      </div>
    }
    @if (summaryData.cancellations > 0) {
      <div class="flex-item highlight">
        <span class="">Cancellation:</span>
        <span class="mob">{{summaryData.cancellations}}</span>
      </div>
    }
    @if (summaryData.ilp > 0) {
      <div class="flex-item">
        <span class="">Individual Learning Plan:</span>
        <span class="mob">{{summaryData.ilp}}</span>
      </div>
    }
    @if (summaryData.sessions > 0) {
      <div class="flex-item">
        <span class="">Session:</span>
        <span class="mob">{{summaryData.sessions}}</span>
      </div>
    }
    @if (summaryData.pr > 0) {
      <div class="flex-item">
        <span class="">Progress Report:</span>
        <span class="mob">{{summaryData.pr}}</span>
      </div>
    }
  </div>
  <app-data-table
    [columns]="columns"
    [data]="rows"
    [pageSize]="5"
    emptyMessage="There are no pending actions">
    <ng-template appColumnCell="task" let-row>
      <span class="tc-task-desc">{{row.actionType.description}}</span>
      <span class="tc-task-short">{{row.actionType.shortDescription}}</span>
    </ng-template>
  </app-data-table>
</div>
<div class="button-padding">
  <button mat-dialog-close input type="button" [mat-dialog-close]="true" class="btn btn-primary divclose">Close</button>
</div>
